// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import FormControl from '@mui/material/FormControl';
import { NumberField } from '../utils/input/numberField';
// Actions
import { updateDurationNights } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitDurationNights(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const duration_days = useSelector((state: AppState) => state.circuit.duration_nights);

    useEffect(() => {
        dispatch(updateDurationNights(duration_days));
    },[circuitData]);

    const onDurationDaysChange = (event: { target: { value: any; }; }) => {
        dispatch(updateDurationNights(event.target.value));

    };
    const resetValue = () => {
        if (isNaN(parseInt(String(duration_days)))){
            dispatch(updateDurationNights(0));
        }
    };

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(updateDurationNights(props.circuit.duration_night));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth variant={ 'outlined' }>
            <NumberField onBlur={resetValue}
                value={ duration_days }
                id={ 'circuit-duration-nights' }
                label={ t('shared.night(s)') }
                onChange={ onDurationDaysChange }
            />
        </FormControl>
    );
}

export default CircuitDurationNights;
